import { makeStyles } from "@mui/styles"

export const useColumnMenuStyles = makeStyles(({ typography }: { typography: any }) => ({
  contentContainer: {
    "&[class*='MuiDialogContent']": {
      backgroundColor: "transparent",
      padding: 0,
    },
    color: "#554854",
    fontSize: typography.pxToRem(14),
    fontWeight: "bold",
  },
  counterContainer: {
    background: "#6B546A",
    borderRadius: "50%",
    color: "#F2F2F5",
    fontSize: "12px",
    height: "20px",
    lineHeight: "20px",
    pointerEvents: "none",
    position: "absolute",
    right: "14px",
    textAlign: "center",
    top: "12px",
    width: "20px",
    zIndex: 10,
  },
  dialogTitle: {
    "&[class*='MuiDialogTitle']": {
      color: "#554854",
      fontWeight: 700,
      lineHeight: "28px",
      marginBottom: "16px",
      padding: 0,
    },
  },
  paper: {
    height: "auto",
    padding: "32px",
    width: "430px",
  },
  resetCustomization: {
    "&[class*='MuiButtonBase-root']": {
      "&:hover": {
        borderColor: "rgba(86, 70, 85, .5)",
      },
      borderColor: "rgba(86, 70, 85, .5)",
      marginTop: "24px",
    },
  },
  switchContainer: {
    "& > div": {
      color: "#333333",
      fontWeight: "normal",
      textTransform: "capitalize",
    },
    width: "60%",
  },
}))
